import { v4 as uuid4 } from 'uuid';

export function uuid() {
  return uuid4();
}